export default "__VITE_ASSET__Dh8dN5j0__"